import { Col, Row } from "antd";
import React from "react";
import { ButtonC } from "src/shared/components";
import "./whatsapp.less";
import whatsappImg from "src/shared/assets/images/landing/whatsapp.png";
import useDomain from "src/shared/hooks/useDomain";

const LWhatsapp = () => {
  const { name, supportPhone, whatsapp } = useDomain();

  return (
    <section id="whatsapps">
      <Row justify="center">
        <Col xs={23} md={22} lg={21}>
          <Row
            justify="space-between"
            className="background"
            align="middle"
            gutter={[10, 30]}
          >
            {supportPhone?.length && (
              <Col className="col-phone">
                <p className="bold">پشتیبانی 24 ساعته، 7 روز هفته </p>
                <span>|</span>
                <p> شماره تماس :{supportPhone?.join(",")}</p>
              </Col>
            )}
            {whatsapp && (
              <Col>
                <ButtonC>
                  <a
                    href={`https://api.whatsapp.com/send/?text=سلام وقت بخیر&phone=${whatsapp}`}
                  >
                    {/* <a href={`https://wa.me/${whatsapp}?text=سلام وقت بخیر`}> */}
                    <img src={whatsappImg} />
                    ارتباط مستقیم در واتس اپ
                  </a>
                </ButtonC>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </section>
  );
};

export default LWhatsapp;
